const textDecorationStyle = {
  name: "text-decoration-style",
  path: "/text-decoration-style",
  title: "Text Decoration Style",
  description: "Utilities for controlling the style of text decoration lines.",
  value: {
    "text-decoration-style": {
      "decoration-solid": "solid",
      "decoration-double": "double",
      "decoration-dotted": "dotted",
      "decoration-dashed": "dashed",
      "decoration-wavy": "wavy"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="underline decoration-solid">This text has a solid underline.</p>
<p class="underline decoration-double">This text has a double underline.</p>
<p class="underline decoration-dotted">This text has a dotted underline.</p>
<p class="underline decoration-dashed">This text has a dashed underline.</p>
<p class="underline decoration-wavy">This text has a wavy underline.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-solid</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-double</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-dotted</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-dashed</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-wavy</code> to control the style of text decoration lines.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-solid</small>
          <p class="underline decoration-solid text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-double</small>
          <p class="underline decoration-double text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-dotted</small>
          <p class="underline decoration-dotted text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-dashed</small>
          <p class="underline decoration-dashed text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-wavy</small>
          <p class="underline decoration-wavy text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
};

export default textDecorationStyle;
<div className="underline decoration-solid decoration-double decoration-dotted decoration-dashed decoration-wavy sr-only"></div>